import { cloneElement } from 'react';
import { useFocusTrap } from '../../hooks';
export var FocusTrap = function (_a) {
    var locked = _a.locked, focusLastOnUnlock = _a.focusLastOnUnlock, children = _a.children;
    var focusRef = useFocusTrap(locked, { focusLastOnUnlock: focusLastOnUnlock });
    return cloneElement(children, { ref: focusRef });
};
